
<div class="card mb-5" [style.margin-left]="data.marginleft" *ngIf="data">
  <div class="card-header" style="border-bottom: none; padding: 4px 6px;">
    <div class="card-title d-flex flex-column">
      <h6 style="margin: 0;" [style.font-size]="data.titleFontSize || '16px'" [style.text-align]="data.titleAlignment || 'center'">{{ (chartTitle || data.title) | capitalCase }}</h6>
    </div>
  </div>
  <div class="card-body" style="padding: 4px;">
    <!-- Slider controls for more than maxVisibleCategories bars -->
    

    <div class="chart-container-wrapper" [style.height]="getResolvedHeight()">
      <div class="chart-area" [style.height]="getResolvedHeight()">
        <div #chartContainer class="chart" [style.height]="getResolvedHeight()" [style.width]="'100%'"></div>

        <!-- DOM scrollbar on the right edge (visible when too many categories) -->
        <div class="scrollbar-track" [style.height]="getResolvedHeight()" *ngIf="allCategories.length > maxVisibleCategories">
          <div class="scrollbar-thumb"
               [style.height]="getScrollbarThumbHeight() + 'px'"
               [style.top]="getScrollbarThumbTop() + 'px'"
               (mousedown)="onScrollbarMouseDown($event)"></div>
        </div>
      </div>
    </div>
  </div>
</div>
